<template>
    <div>
        <div class="block-container">
            <div class="content-caption bg-white dashed">
                <span>选择工程师</span>
            </div>
            <div class="form-single">
                <div class="title required">请选择工程师</div>
                <div class="content">
                    <div v-for="engineer in servcWorkVoucherStaffList">
                        <p>
                            <span>{{engineer.engineerName}}</span>
                            <el-radio :label="engineer.engineerId" v-model="checkValue">是否主工程师&nbsp;&nbsp;</el-radio>
                        </p>
                    </div>
                    <label class="mr20">
                        <a class="swb-btn-link" @click="engineerSelect">+ 选择工程师</a>
                    </label>
                </div>
            </div>
            <div class="form-single" v-if="optFlag == 'change'">
                <div class="title required">请选择转单原因</div>
                <div class="content">
                    <el-select placeholder="请选择" class="fl" v-model="transDesc" :clearable=true>
                        <el-option v-for="transCause in transCauseList" :key="transCause.id" :label="transCause.name" :value="transCause.name"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servicerApi from '../../api/servicer'

    import SwbServicerEngineerListForSelect from '../orgStruct/ServicerEngineerListForSelect';
    Vue.regist(SwbServicerEngineerListForSelect);

    export default {
        name: 'swb-to-change-engineer',
        // path: '',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '转单操作弹框',
        props: ['ssuId', 'optFlag', 'workVoucher', 'onlyShowAll'],
        data: function () {
            return {
                servcWorkVoucherStaffList: [], // 工程师列表
                transCauseList: [], // 转单原因列表
                checkValue: '',
                transDesc: null // 选中的转单原因
            }
        },
        created: function () {
            if(!Utils.isNoB(this.optFlag) && this.optFlag == 'change') {
                this.getWorkTransCauseList();
            }
        },
        methods: {
            //选择工程师
            engineerSelect: function () {
                let self = this;
                let ssuIdList = [];
                let ssuId = self.ssuId;
                if(!Utils.isNoB(ssuId)) {
                    ssuIdList.push(ssuId);
                }
                Vue.$showDialog({
                    title: '服务工程师 - 选择',
                    showCloseBtn: true,
                    width: 1200,
                    height: 750,
                    template: '<div>' +
                    '<swb-servicer-engineer-list-for-select :disabled="true" :workVoucherId="workVoucherId" :ssuIdList="ssuIdList" :servicerShopId="servicerShopId" :goodsCatId="goodsCatId" :servcId="servcId" :servcType="servcType" :retailerShopId="retailerShopId" :onlyShowAll="onlyShowAll" ref="swb_servicer_engineer_list_select"></swb-servicer-engineer-list-for-select>' +
                    '</div>',
                    data: {
                        ssuIdList: [],
                        servicerShopId: self.workVoucher.servicerShopId,
                        goodsCatId: self.workVoucher.devcCatId,
                        servcId: self.workVoucher.servcId,
                        servcType: self.workVoucher.servcType,
                        retailerShopId: self.workVoucher.buyerShopId,
                        workVoucherId: self.workVoucher.id,
                        onlyShowAll: self.onlyShowAll
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_servicer_engineer_list_select.getDlgResult() || {};
                        if(result != null && result.type === 'info') {
                            let engineerList = result.data;
                            self.servcWorkVoucherStaffList = [];
                            if(!Utils.isNoB(engineerList) && engineerList.length > 0) {
                                for(let i = 0; i < engineerList.length; i++) {
                                    let engineer = engineerList[i];
                                    let servcWorkVoucherStaff = {};
                                    servcWorkVoucherStaff.engineerId = engineer.id;
                                    servcWorkVoucherStaff.engineerName = engineer.name;
                                    self.servcWorkVoucherStaffList.push(servcWorkVoucherStaff);
                                }
                                self.checkValue = engineerList[0].id;
                            }
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            this.ssuIdList = ssuIdList;
                        }
                    }
                });
            },
            // 获取转单原因
            getWorkTransCauseList: function () {
                let self = this;
                let postData = {
                    filterItems: {
                        disabled: false
                    }
                };
                servicerApi.getServcWorkTransCauseList(postData, function (result) {
                    if(result.type == 'info') {
                        //
                        self.transCauseList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                if(!Utils.isNoB(this.checkValue)) {
                    let servcWorkVoucherStaffList = this.servcWorkVoucherStaffList;
                    for(let i = 0; i < servcWorkVoucherStaffList.length; i++) {
                        let servcWorkVoucherStaff = servcWorkVoucherStaffList[i];
                        if(this.checkValue == servcWorkVoucherStaff.engineerId) {
                            servcWorkVoucherStaff.chiefFlag = true;
                        } else {
                            servcWorkVoucherStaff.chiefFlag = false;
                        }
                    }
                    let resData = {};
                    resData.servcWorkVoucherStaffList = servcWorkVoucherStaffList;
                    if(!Utils.isNoB(this.optFlag) && this.optFlag == 'change') {
                        if(!Utils.isNoB(this.transDesc)) {
                            resData.transDesc = this.transDesc;
                            result.type = "info";
                            result.data = resData;
                        } else {
                            result.type = "warn";
                            result.message = "请选择转单原因";
                        }
                    } else {
                        result.type = "info";
                        result.data = resData;
                    }
                } else {
                    result.type = "warn";
                    result.message = "请选择主工程师";
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ToChangeEngineers.vue